<template>
  <div class="tourOptions_wrap">
    <div class="tourOptions-content-wrap">
      <div class="tourOptions-option-header">
        <p class="tourOptions-option-header-title">Trip</p>
        <p class="tourOptions-option-header-price">From Price</p>
        <p class="tourOptions-option-header-selected" />
      </div>

      <div
        v-if="selectedOption"
        class="tourOptions-option"
        :data-tripId="selectedOption.tourId"
        tabindex="-1"
      >
        <div
          class="tourOptions is-selected"
          :class="{
            'is-grayed-out': isGrayedOut
          }"
        >
          <div class="tourOptions-data">
            <p class="tourOptions-title">
              {{ selectedOption.tripName }}
            </p>
            <p class="tourOptions-price">
              {{ selectedOption.price }}
              <br />
              <span
                v-if="selectedOption.originalPrice && displayOriginalAdultPriceForTour"
                class="strikethrough"
              >
                {{ selectedOption.originalPrice }}
              </span>
            </p>
          </div>
          <div class="tourOptions-status">
            <span class="icon-status">
              <i class="fa fa-check" />
            </span>
          </div>
        </div>
      </div>
      <div
        v-for="(
          { tourId, tripName, price, originalPrice, tourOptionId, link }, index
        ) in filteredOptions.slice(0, count)"
        :key="index"
        class="tourOptions-option"
        :data-tripId="tourId"
        tabindex="0"
        @click="sendTourId(tourOptionId, link)"
        @keyup.enter="sendTourId(tourOptionId, link)"
      >
        <div class="tourOptions">
          <div class="tourOptions-data">
            <p class="tourOptions-title">
              {{ tripName }}
            </p>
            <p class="tourOptions-price">
              {{ price }}
              <br />

              <span v-if="originalPrice && displayOriginalAdultPriceForTour" class="strikethrough">
                {{ originalPrice }}
              </span>
            </p>
          </div>
          <div class="tourOptions-status">
            <span class="icon-status">
              <i class="fa fa-check" />
            </span>
          </div>
        </div>
        <div v-if="isSelected === tourOptionId && tourLoading" class="tourFilters-section__loader">
          <div class="loader-bar" />
        </div>
      </div>
    </div>

    <div v-if="!tourOptionsData?.length" class="tourOptions__nodata">
      Looks like we couldn't find any trips matching your search criteria. Please try again.
    </div>

    <button
      v-if="tourOptionsData?.length > count"
      class="tourOptions__showmore"
      @click="showMore()"
    >
      Load more...
    </button>
  </div>
</template>

<script>
export default {
  props: ['touroptions', 'count', 'tourLoading', 'allOptions'],
  emits: ['tourId', 'itinerary-status'],
  data() {
    return {
      isSelected: window.Cms?.raqModal?.tour?.tourOptionId || null,
      regionalSettings: window.Cms?.regionalSettings || {},
      isGrayedOut: false,
      tourOptionsData: this.touroptions,
      displayOriginalAdultPriceForTour:
        window.Cms?.raqModal?.tour?.displayOriginalAdultPrice || false
    };
  },
  computed: {
    selectedOption() {
      return this.allOptions?.find((option) => option.tourOptionId === this.isSelected);
    },
    filteredOptions() {
      return this.touroptions.filter((option) => option.tourOptionId !== this.isSelected);
    }
  },
  watch: {
    touroptions: {
      immediate: true,
      handler(newOptions) {
        this.updateGrayOutState(newOptions);
      }
    },
    isSelected() {
      this.updateGrayOutState(this.touroptions);
    }
  },
  mounted() {
    this.scrollToHash();
  },
  methods: {
    scrollToHash() {
      this.$nextTick(() => {
        const hash = window.location.hash;
        if (hash) {
          const targetElement = document.querySelector(hash);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    },
    updateGrayOutState(options) {
      this.isGrayedOut = !options.some((option) => option.tourOptionId === this.isSelected);
    },
    sendTourId(tourOptionId, tourLink, scrollToId = 'tour-filters-section') {
      this.isSelected = tourOptionId;
      this.$emit('tourId', tourLink);

      this.tourUpdate = true;
      this.$emit('itinerary-status', true);
      setTimeout(() => {
        const { pathname, search } = window.location;
        const updatedPath = pathname.replace(/\/\d+\/?$/, `/${tourOptionId}`);
        window.location.href = `${updatedPath}${search}#${scrollToId}`;
      }, 2000);
    },

    showMore() {
      this.count += 5;
    }
  }
};
</script>
